import config from '../config';
import { URL } from '../constants';

const { featureToggles } = config;

export const goTo = (link: string) => {
  window.location.href = link;
};

export const getUrl = (
  page: string,
  eventId: string,
  id?: string,
  isWithOrigin?: boolean,
) => {
  switch (page) {
    case URL.VIDEO_BUILDER:
      return `/${eventId}${URL.VIDEO_BUILDER}`;
    case URL.VB_ASSIGNEE:
      return `/${eventId}${URL.VB_ASSIGNEE}`;
    case URL.VB_PEOPLE:
      return `/${eventId}${URL.VB_PEOPLE}`;
    case URL.VB_HL_REEL:
      return `/${eventId}${URL.VB_HL_REEL}`;
    case URL.VB_CLIPS:
      return `/${eventId}${URL.VB_CLIPS}`;
    case URL.VB_ANALYSIS:
      return `/${eventId}${URL.VB_ANALYSIS}`;
    case URL.VB_REVIEW:
      return `/${eventId}${URL.VB_REVIEW}`;
    case URL.VB_SHARE:
      return `/${eventId}${URL.VB_SHARE}`;

    case URL.PROJECT_SETTINGS:
      return `${eventId ? '/' + eventId : ''}${URL.PROJECT_SETTINGS}${id ? '/' + id : ''}`;
    case URL.PROJECT_ANALYTICS:
      return `/${eventId}${URL.PROJECT_ANALYTICS}`;
    case URL.PROJECT_MISSING_ASSETS:
      return `/${eventId}${URL.PROJECT_MISSING_ASSETS}`;

    case URL.CHECK_IN:
      return `${isWithOrigin ? window.location.origin : ''}${URL.CHECK_IN}${eventId}${id ? '/' + id : ''}`;
    case URL.SHARE:
      return `${URL.SHARE}${eventId}${id ? '/' + id : ''}`;

    default:
      return '/';
  }
};

export const getHelpUrl = (
  topic?: string,
  article?: string,
  section?: string,
) => {
  return (
    URL.HELP +
    (topic ? `/${topic}` : '') +
    (article ? `/${article}` : '') +
    (section ? `#${section}` : '')
  );
};

export const getShareLink = (eventId: string, faceId?: string) => {
  const hubLink = window.location.origin + URL.SHARE + eventId;

  if (faceId) return hubLink + '/' + faceId;

  return hubLink;
};

export const getCheckInRedirectUri = (eventId: string) => {
  return `${featureToggles.auth0 ? window.location.origin : ''}${URL.CHECK_IN_REDIRECT}?eventId=${eventId}`;
};

export const get3rdPartyRedirectUri = (
  type: string,
  purpose: string,
  isEncode?: boolean,
) => {
  switch (type) {
    case 'linkedin':
      const uri = `${window.location.origin}${URL.LINKEDIN_CALLBACK}?purpose=${purpose}`;
      return isEncode ? encodeURIComponent(uri) : uri;

    default:
      return '';
  }
};

export const getVBLinkParts = (pathname: string) => {
  const pathnameParts = pathname.split('/');
  const eventId = pathnameParts[1];
  let page = pathnameParts[3];

  if (page === 'highlight-reel') page = 'hl_reel';

  return { eventId, page };
};
